import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const trackerUrl = process.env.REACT_APP_PUBLIC_TRACKER_URL;
const siteId = process.env.REACT_APP_PUBLIC_TRACKER_SITE_ID;
if (!trackerUrl || !siteId) throw new Error("Public tracker URL and site ID must be configured.");

export function PublicPageTracker() {
  const { pathname } = useLocation();
  const enabled = pathname === "/" || pathname === "/articles" || pathname.startsWith("/articles/");

  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    let script;
    const start = async () => {
      try {
        // The older script has no cleanup API: never execute it on a routed app.
        const response = await fetch(trackerUrl, { method: "HEAD", credentials: "omit", cache: "no-store", signal: controller.signal });
        if (controller.signal.aborted || !response.ok || response.headers.get("X-SRD-Route-Scoped") !== "1") return;
        script = document.createElement("script");
        script.async = true;
        script.src = trackerUrl;
        script.dataset.site = siteId;
        script.dataset.srdScope = "public";
        script.dataset.testid = "public-page-tracker-script";
        document.head.appendChild(script);
      } catch {
        // Unavailable analytics must not affect public pages or expose private routes.
      }
    };
    start();
    return () => {
      controller.abort();
      window.dispatchEvent(new CustomEvent("srd:stop", { detail: { site: siteId } }));
      script?.remove();
    };
  }, [enabled]);

  useEffect(() => {
    if (enabled) window.dispatchEvent(new CustomEvent("srd:navigate", { detail: { site: siteId } }));
  }, [pathname, enabled]);

  return null;
}